import React from 'react';

import LayoutCabinet from 'layouts/LayoutCabinet';

import { useProfileData } from '../../hooks';
import { ChildrenProps } from '../../utils';
import { LayoutPublic } from '../index';

import './LayoutNotFound.scoped.scss';

const LayoutNotFound = ({ children }: ChildrenProps) => {
  const profileData = useProfileData();
  const isVerified = profileData.lenderVerified;
  const Container = isVerified ? LayoutCabinet : LayoutPublic;

  if (!children) {
    return (
      <Container>
        <h2 className="not-found__text">Страница не найдена</h2>
      </Container>
    );
  }
  // TODO: style 404 layout
  return <>{children}</>;
};

export default LayoutNotFound;
